export default "__VITE_ASSET__BDPWZx$z__"